import styled from 'styled-components';

export const WrapperVideo = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
